import { useContext, useMemo } from 'react';
import FeatureFlagsContext from './Context';
import { FEATURE_FLAG_KEY } from './checkFeatureFlag';

const useFeatureFlag = (featureFlagKey: FEATURE_FLAG_KEY): boolean => {
  const { checkFeatureFlag } = useContext(FeatureFlagsContext);

  const value = useMemo(() => checkFeatureFlag(featureFlagKey), [checkFeatureFlag, featureFlagKey]);

  return value;
};

export default useFeatureFlag;
